import { render } from "./PostCategory.vue?vue&type=template&id=6e525d84"
import script from "./PostCategory.vue?vue&type=script&lang=js"
export * from "./PostCategory.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/webik150-website-vue/webik150-website-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__